import React, { useContext, useEffect, useState } from "react";
import {
  Autoplay,
  EffectCoverflow,
  Navigation,
  Pagination,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
import mision from "../../assets/image/mision.webp";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { az } from "date-fns/locale";
import { format } from "date-fns";
import GetInTouch from "./GetInTouch";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
import { Calendar } from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { NavLink } from "react-router-dom";
import slugify from "react-slugify";
const WhyDoPeople = () => {
  const { blog, loading, testimonials, error } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [changeDate, setChangeDate] = useState(null);
  const [findDate, setFindDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  const [selectedDay, setSelectedDay] = useState(null);

  const [testiModal, setTestiModal] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  // Tarih formatını standart hale getirme
  const convertToDate = (dateString) => {
    const dateParts = dateString.trim().split(/[\./]/); // Hem . hem de / için ayırma
    return new Date(`${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`); // MM/DD/YYYY formatı
  };

  useEffect(() => {
    const dates = blog.map((item) => convertToDate(item.date));
    setHighlightedDates(dates);
  }, [blog]);

  const handleDateChange = (dates) => {
    setChangeDate(dates);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (changeDate) {
      const formatDate = format(changeDate, "dd/MM/yyyy");
      setFindDate(formatDate);
    }
  }, [changeDate]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const findBlogData = blog.filter(
    (item) => format(convertToDate(item.date), "dd/MM/yyyy") === findDate
  );

  const openModal = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setTestiModal(true);
  };

  // Modal bağlama funksiyası
  const closeModalTesti = () => {
    setTestiModal(false);
    setSelectedTestimonial(null);
  };

  return (
    <>
      <div
        className="testimonial-section section section-padding"
        data-aos="fade-up"
      >
        <div className="container py-5 ">
          <h4 className="text-start" style={{ textTransform: "uppercase" }}>
            {t.homedate}
          </h4>
          <div
            className="row p-5"
            style={{ border: "6px solid #f1f1f1", borderRadius: "8px" }}
          >
            <div className="col-lg-8">
              <div
                className="about-content testimonial-content mb-sm-50 mb-xs-50"
                style={{ maxWidth: "100%" }}
              >
                <span className="sub-title">{t.selectdate}</span>
                <h2
                  className="title"
                  style={{ fontSize: "20px", lineHeight: "30px" }}
                >
                  {t.datetitle}
                </h2>
                <p>{t.datedesc}</p>
                <button className="btn btn-primary">
                  <NavLink to="/chronology">
                  {t.readmore}
                  </NavLink>
                </button>
              </div>
            </div>

            {selectedDay}
            <div className="col-lg-4">
              <div className="d-flex justify-content-center align-items-center">
                <DatePicker
                  selectsRange
                  highlightDates={highlightedDates} // API'den gelen tarihleri vurgulamak
                  inline
                  className="custom-datepicker"
                  onChange={handleDateChange}
                  locale={az}
                  dayClassName={(date) => {
                    if (
                      highlightedDates.some(
                        (d) => d.toDateString() === date.toDateString()
                      )
                    ) {
                      return "highlighted-day"; // Bu sınıfı kullanarak stil uygulayın
                    } else {
                      return "disabled-day"; // Seçilemeyen tarihler için özel sınıf
                    }
                  }}
                  filterDate={(date) =>
                    highlightedDates.some(
                      (d) => d.toDateString() === date.toDateString()
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for displaying selected date */}
      {isModalOpen && (
        <div className="modal-overlay" data-aos="fade-up" onClick={closeModal}>
          <div
            className="modal-content"
            style={{
              height: `${findBlogData.length > 3 ? "500px" : "auto"}`,
              overflowY: `${findBlogData.length > 3 && "scroll"}`,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              {findBlogData.length > 0 && (
                <>
                  <h3>Tarix {findDate}</h3>
                  <img src={findBlogData.img} alt="" className="img-fluid" />
                  <p>
                    Tarixə uyğun olaraq {findBlogData.length} məlumat tapıldı.
                  </p>
                </>
              )}
              {findBlogData.map((item) => {
                return (
                  <NavLink
                    to={`/${slugify(`${item.id}-${item.name}`)}`}
                    className="d-flex justify-content-start align-items-center p-3 my-2"
                    style={{ background: "#e4e4e4", borderRadius: "20px" }}
                  >
                    <img
                      src={item.img}
                      alt=""
                      className="img-fluid"
                      style={{ width: "200px" }}
                    />
                    <h4 className="ms-3">{item.name}</h4>
                    <br />

                    <br />
                  </NavLink>
                );
              })}
            </div>
            {/* <button className="btn btn-secondary" onClick={closeModal}>
              Daha Ətraflı
            </button> */}
          </div>
        </div>
      )}

      <div className="testimonial-section section ">
        <div className="parallax1">
          <div className="outline"></div>
        </div>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-5">
              <div className="about-content testimonial-content mb-sm-50 mb-xs-50">
                <span className="sub-title">{t.testimonials}</span>
                <h2
                  className="title"
                  dangerouslySetInnerHTML={{ __html: t.testtitle }}
                />
                <p>{t.testdesc}</p>
                <NavLink to="/feedbacks">
                  <button className="btn btn-primary">{t.readmore}</button>
                </NavLink>
              </div>
            </div>
            <div className="col-lg-7">
              <div
                className="testimonial-slider-vertical swiper-container"
                data-aos="fade-up"
              >
                <div className="swiper-wrapper">
                  <Swiper
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={"auto"}
                    coverflowEffect={{
                      rotate: 50,
                      stretch: 0,
                      depth: 100,
                      modifier: 1,
                      slideShadows: true,
                    }}
                    pagination={true}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    modules={[EffectCoverflow, Pagination, Autoplay]}
                    className="mySwiper"
                  >
                    {testimonials.map((item) => {
                      return (
                        <SwiperSlide key={item.id}>
                          <div
                            className="swiper-slide"
                            style={{ cursor: "pointer" }}
                            onClick={() => openModal(item)}
                          >
                            <div
                              className="testimonial-two testimonial-three"
                              style={{ background: "#f5f5f5" }}
                            >
                              <div className="content">
                                <h4 className="title">
                                  {testiModal}
                                  {item.name}
                                </h4>
                                {item.text && (
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        language == "az" ? item.text.slice(0, 200) + "..." : language == "en" ? item.textEn.slice(0, 200) + "..." : language == "ru" ? item.textRu.slice(0, 200) + "..." : language == "tr" ? item.textTr.slice(0, 200) + "..." : "yoxdur"
                                    }}
                                  />
                                )}
                              </div>
                              <div className="author-info">
                                <div className="image">
                                  <img src={item.img} alt="" />
                                </div>
                                <div className="cite">
                                  <h6 className="name">{item.name}</h6>
                                  <span className="position">/ {item.job}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
                <div className="swiper-pagination" />
              </div>
            </div>
          </div>
        </div>
        {testiModal && selectedTestimonial && (
          <div className="modal-overlayTest" onClick={closeModal}>
            <div
              className="modal-content"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <button
                className="close-btn d-flex justify-content-end"
                onClick={closeModalTesti}
              >
                ✖
              </button>
              <div className="testiIcon">
                <i className="fa-solid fa-quote-left"></i>
              </div>
              <img
                src={selectedTestimonial.img}
                alt={selectedTestimonial.name}
                className="testimonial-img"
              />
              <div className="modalDesc">
                <h3>{selectedTestimonial.name}</h3>
                <p
                  dangerouslySetInnerHTML={{ __html: language == "az" ? selectedTestimonial.text.slice(0, 200) + "..." : language == "en" ? selectedTestimonial.textEn.slice(0, 200) + "..." : language == "ru" ? selectedTestimonial.textRu.slice(0, 200) + "..." : language == "tr" ? selectedTestimonial.textTr.slice(0, 200) + "..." : "yoxdur" }}
                />
              </div>
            </div>
          </div>
        )}
        <GetInTouch />
      </div>
    </>
  );
};

export default WhyDoPeople;
